const FndUserQueryFields = [
    {
        name: '姓名',
        code: 'displayName',
        column: true,
        defaultFilter: true,
        width: 100
    },
    {
        name: '手机号',
        code: 'phone',
        align: 'center',
        column: true,
        defaultFilter: true,
        width: 100
    },
    {
        name: '邮箱',
        code: 'email',
        align: 'center',
        defaultFilter: true,
        width: 180
    },
    {
        name: '性别',
        code: 'sex',
        width: 80
    },
    {
        name: '状态',
        code: 'state',
        width: 80
    }
]
export default FndUserQueryFields;